import React from 'react';
import { Modal, Table, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'redux/store';
import { selectHour12Option } from 'redux/selectors/userSettings';
import { OpenPeriod } from './types';
import { formatPeriodDatetime, calculateDuration } from './helpers';

interface OpeningMomentsModalProps {
  show: boolean;
  onHide: () => void;
  periods: OpenPeriod[];
  isLoading: boolean;
  error: string | null;
  windowName: string;
  timezone?: string;
}

const OpeningMomentsModal: React.FC<OpeningMomentsModalProps> = ({ show, onHide, periods, isLoading, error, windowName, timezone }) => {
  const { t } = useTranslation();
  const hour12 = useAppSelector(selectHour12Option);

  return (
    <>
      <style>{`.opening-moments-backdrop { z-index: 1059 !important; }`}</style>
      <Modal show={show} onHide={onHide} size="lg" backdrop="static" style={{ zIndex: 1060 }} backdropClassName="opening-moments-backdrop">
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Open Periods')}: {windowName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isLoading && (
            <div className="text-center py-4">
              <Spinner animation="border" role="status" />
              <div className="mt-2">{t('Evaluating schedule...')}</div>
            </div>
          )}

          {error && !isLoading && <Alert variant="danger">{error}</Alert>}

          {!isLoading && !error && periods.length === 0 && <Alert variant="info">{t('No open periods found in the evaluation range.')}</Alert>}

          {!isLoading && !error && periods.length > 0 && (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t('Opens')}</th>
                  <th>{t('Closes')}</th>
                  <th>{t('Duration')}</th>
                </tr>
              </thead>
              <tbody>
                {periods.map((period, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{formatPeriodDatetime(period.open, timezone, hour12)}</td>
                    <td>{formatPeriodDatetime(period.close, timezone, hour12)}</td>
                    <td>{calculateDuration(period.open, period.close)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OpeningMomentsModal;
